import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetBudgetDetails = createAsyncThunk(
  "BudgetDetails/GetBudgetDetails",
  async (AI_ApplicationInformationId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/BudgetDetails/BudgetDetails", {
        AI_ApplicationInformationId: AI_ApplicationInformationId,
      });

      // Extract data from the response object
      const data = response.data; // Assuming response has a "data" field
      //console.log(data, "BudgetDetailsss");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const BudgetDetails = createSlice({
  name: "BudgetDetails",
  initialState: {
    BudgetDetails: {},
    loadingBudgetDetails: false,
    errorBudgetDetails: null,
  },
  reducers: {
    SetBudgetDetails: (state, action) => {
      state.BudgetDetails = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetBudgetDetails.pending, (state, action) => {
        state.loadingBudgetDetails = true;
        state.BudgetDetails = action.payload;
        state.errorBudgetDetails = null;
      })
      .addCase(GetBudgetDetails.fulfilled, (state, action) => {
        state.loadingBudgetDetails = false;
        state.BudgetDetails = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetBudgetDetails.rejected, (state, action) => {
        state.loadingBudgetDetails = false;
        state.errorBudgetDetails = action.payload;
      });
  },
});
export const { SetBudgetDetails } = BudgetDetails.actions;

export default BudgetDetails.reducer;
